import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputProps,
  SelectProps,
  TextareaProps,
} from '@chakra-ui/react'
import { FormikProps } from 'formik'
import React, { Fragment } from 'react'
import { getFieldValue, renderField } from './utils'

export type FieldType = 'input' | 'date' | 'textarea' | 'select'

export interface DynamicFieldProps {
  id: string
  title?: string
  type: FieldType
  options?: { label: string; value: string }[]
  inputProps?: InputProps
  textAreaProps?: TextareaProps
  selectProps?: SelectProps
}

export interface DynamicFormJSXField {
  jsx: JSX.Element
  key: string
}

export type UnifiedField = DynamicFormJSXField | DynamicFieldProps

interface DynamicFormProps<T> {
  formikProps: FormikProps<T>
  inputFields: UnifiedField[]
}

const DynamicForm: React.FC<DynamicFormProps<any>> = ({ formikProps, inputFields }) => {
  return (
    <FormControl onSubmit={() => formikProps.handleSubmit()}>
      {inputFields.map((field, index) =>
        'jsx' in field ? (
          <Fragment key={field.key}>{field.jsx}</Fragment>
        ) : (
          <FormControl
            key={field.id}
            isInvalid={
              getFieldValue(formikProps.errors, field.id) &&
              getFieldValue(formikProps.touched, field.id)
            }
          >
            {field.title && <FormLabel>{field.title}</FormLabel>}
            {renderField(field, formikProps)}
            <FormErrorMessage>{getFieldValue(formikProps.errors, field.id)}</FormErrorMessage>
          </FormControl>
        )
      )}
    </FormControl>
  )
}

export default DynamicForm
